import { TriangleAlert } from 'lucide-react';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './MocaFlag.module.scss';

export const isLowMoca = (result) => result?.maxScore === 30 && Math.round(result.score) < 20;

const MocaFlag = ({ score, className = '' }) => (
  <span className={`${styles.flag} ${className}`}>
    <TriangleAlert size={13} className={styles.icon} aria-hidden="true" />
    {score != null ? `MoCA ${score} · ` : ''}Consider in-person assessment
  </span>
);

MocaFlag.propTypes = {
  score: PropTypes.number,
  className: PropTypes.string,
};

export default MocaFlag;
